export default function setFormData (values, fileList) {
    const form = new FormData();
    form.append('name', values.commerceName);
    form.append('cuit', values.commerceCuit);
    form.append('code', values.commerceCode);
    form.append('business_unit', values.commerceUnit);
    form.append('telephone', values.commerceNumber);
    form.append('email', values.commerceEmail);
    form.append('category', values.commerceType);
    values.commerceStreet && form.append('store_address.street', values.commerceStreet);
    values.commerceStreetNumber && form.append('store_address.number', values.commerceStreetNumber);
    values.commercePostalCode && form.append('store_address.postal_code', values.commercePostalCode);
    values.commerceLocation && form.append('store_address.county', values.commerceLocation);
    values.commerceProvince && form.append('store_address.province', values.commerceProvince);
    values.commerceFloor && form.append('store_address.metadata', JSON.stringify({ floor: values.commerceFloor }));
    fileList.forEach((file, index) => {
        form.append(`file${index}`, file.blobFile);
    });
    return form;
};
